import { Outlet } from "react-router-dom";
import { useState } from "react";
import DeletePopup from "../DeletePopup";
import ConfirmPopup from "../ConfirmPopup";
import AttachmentView from "../AttachmentView";
import { SideBar } from "../common/Sidebar";
import { TopBar } from "../common/Topbar";
import { Profile } from "../../pages/profile/Profile";
import { GlobalTenantBanner } from "../GlobalTenantBanner";
import { TenantSubscriptionBanner } from "../TenantSubscriptionBanner";

const MainLayout = () => {
  const [fullScreen, setFullScreen] = useState<boolean>(true);

  const handleScreen = () => {
    setFullScreen(!fullScreen);
  }

  return (
    <div className="flex">
      <SideBar handleScreen={handleScreen} />
      <div className={`${fullScreen ? 'w-[calc(100%-224px)]' : 'w-[calc(100%-50px)]'} h-max`}>
        <TopBar />
        <Profile />
        <DeletePopup />
        <GlobalTenantBanner />
        <TenantSubscriptionBanner />
        <ConfirmPopup />
        <AttachmentView />
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
